(function(){
  // reveal on scroll
  var els=document.querySelectorAll('.reveal');
  if('IntersectionObserver' in window){
    var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('is-visible');io.unobserve(e.target);}});},{threshold:.12});
    els.forEach(function(el){io.observe(el);});
  } else { els.forEach(function(el){el.classList.add('is-visible');}); }

  // product: gallery + variants + qty
  document.querySelectorAll('[data-product]').forEach(function(root){
    var dataEl=root.querySelector('[data-product-json]');
    if(!dataEl) return;
    var product=JSON.parse(dataEl.textContent);
    var idInput=root.querySelector('input[name="id"]');
    var addBtn=root.querySelector('[data-add]');
    var priceEl=root.querySelector('[data-price]');
    var compareEl=root.querySelector('[data-compare]');
    var mainImg=root.querySelector('.gallery__img');
    var fmt=function(c){return new Intl.NumberFormat('ja-JP',{style:'currency',currency:root.dataset.currency||'JPY'}).format(c/100);};
    function current(){
      var sel=[];root.querySelectorAll('[data-option]').forEach(function(g){var c=g.querySelector('input:checked');sel.push(c?c.value:null);});
      return product.variants.find(function(v){return v.options.every(function(o,i){return o===sel[i];});});
    }
    function setImage(src,alt){ if(mainImg&&src){mainImg.src=src;mainImg.removeAttribute('srcset');if(alt)mainImg.alt=alt;} }
    root.querySelectorAll('[data-option] input').forEach(function(inp){
      inp.addEventListener('change',function(){
        var v=current();
        if(!v){addBtn.disabled=true;addBtn.textContent='選択できません';return;}
        idInput.value=v.id;
        priceEl.textContent=fmt(v.price);
        if(compareEl){ if(v.compare_at_price>v.price){compareEl.hidden=false;compareEl.textContent=fmt(v.compare_at_price);} else {compareEl.hidden=true;} }
        addBtn.disabled=!v.available;
        addBtn.textContent=v.available?addBtn.dataset.label:'売り切れ';
        if(v.featured_image) setImage(v.featured_image.src.replace(/(\.[a-z]+)(\?|$)/i,'$1$2'), v.featured_image.alt);
        var url=new URL(window.location.href);url.searchParams.set('variant',v.id);history.replaceState({},'',url);
      });
    });
    root.querySelectorAll('[data-thumb]').forEach(function(t){
      t.addEventListener('click',function(){
        root.querySelectorAll('[data-thumb]').forEach(function(x){x.setAttribute('aria-current','false');});
        t.setAttribute('aria-current','true');
        setImage(t.dataset.src,t.dataset.alt);
      });
    });
    root.querySelectorAll('[data-qty]').forEach(function(q){
      var input=q.querySelector('input');
      q.querySelectorAll('button').forEach(function(b){b.addEventListener('click',function(){var n=parseInt(input.value||'1',10)+parseInt(b.dataset.step,10);input.value=Math.max(1,n);});});
    });
  });

  // sort select
  document.querySelectorAll('[data-sort]').forEach(function(s){
    s.addEventListener('change',function(){var u=new URL(window.location.href);u.searchParams.set('sort_by',s.value);window.location=u.toString();});
  });
})();
